import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import MeetForm from "./pages/MeetForm";
import RunSheet from "./pages/RunSheet";
import Reset from "./pages/Reset";
import Signup from "./pages/Signup";
import "./App.css";

function App() {
  const location = useLocation();
  const isRunSheet = location.pathname.includes("/runsheet");
  return (
    <div className={`App ${isRunSheet ? "app-runsheet" : ""}`}>
      <div className={`app-shell ${isRunSheet ? "wide" : ""}`}>
        <section className={`panel ${isRunSheet ? "panel-wide" : ""}`}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/meet/new" element={<MeetForm />} />
            <Route path="/meet/:meetId" element={<MeetForm />} />
            <Route path="/meet/:meetId/runsheet" element={<RunSheet />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </section>
      </div>
    </div>
  );
}

export default App;
